export const TheaterPage = () => {
  return (
    <>
      <div>推しメン</div>
    </>
  )
}
